export const Types = {
    GET_NOTIFICATIONS: "GET_NOTIFICATIONS",
    SET_NOTIFICATIONS: "SET_NOTIFICATIONS",
    GET_ACTIVE_COUNTS: "GET_ACTIVE_COUNTS",
    SET_ACTIVE_COUNTS: "SET_ACTIVE_COUNTS",
    GET_AUTONOMOUS_ACTIVE_COUNTS: "GET_AUTONOMOUS_ACTIVE_COUNTS",
    SET_AUTONOMOUS_ACTIVE_COUNTS: "SET_AUTONOMOUS_ACTIVE_COUNTS",
    GET_BARCODE_CONTEXT: "GET_BARCODE_CONTEXT",
    SET_BARCODE_CONTEXT: "SET_BARCODE_CONTEXT",
};

export const getNotificationList = (userName) => ({
    type: Types.GET_NOTIFICATIONS,
    payload: userName,
});

export const setNotificationList = (payload) => ({
    type: Types.SET_NOTIFICATIONS,
    payload: payload,
});

export const getActiveCounts = (userName) => ({
    type: Types.GET_ACTIVE_COUNTS,
    payload: userName,
});

export const setActiveCounts = (payload) => ({
    type: Types.SET_ACTIVE_COUNTS,
    payload: payload,
});

export const getAutonomousActiveCounts = (payload) => ({
    type: Types.GET_AUTONOMOUS_ACTIVE_COUNTS,
    payload: payload,
});

export const setAutonomousActiveCounts = (payload) => ({
    type: Types.SET_AUTONOMOUS_ACTIVE_COUNTS,
    payload: payload,
});

export const getBarCodeContext = (payload) => ({
    type: Types.GET_BARCODE_CONTEXT,
    payload: payload,
});

export const setBarCodeContext = (payload) => ({
    type: Types.SET_BARCODE_CONTEXT,
    payload: payload.data,
});
